import React from "react";
import BaseGrid from "Components/Fragment/BaseGrid";
import SelectFilterCategory from "./SelectFilterCategory";
import SelectFilterTags from "./SelectFilterTags";
import { useFilter } from "../context";

const FilterSection = ({ languageContext }) => {
  const { state, setCategoryId, setTagFilter } = useFilter();

  return (
    <BaseGrid childWidth="auto" direction="column">
      <SelectFilterCategory
        categoryId={state.categoryId}
        onCategoryChange={setCategoryId}
        languageContext={languageContext}
        sx={{ maxWidth: "250px !important" }}
      />

      <SelectFilterTags
        setTagFilter={setTagFilter}
        languageContext={languageContext}
        sx={{ maxWidth: "250px !important" }}
      />
    </BaseGrid>
  );
};

export default FilterSection;
